module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section-comment container",
    staticStyle: {
      "padding-top": "15px"
    },
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-duration": "100"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column has-text-centered"
  }, [_c('vue-disqus', {
    staticStyle: {
      "padding": "10px",
      "padding-bottom": "15px"
    },
    attrs: {
      "shortname": "noctorus"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column has-text-centered"
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 10px 15px"
    }
  }, [_c('div', {
    staticClass: "fb-comments",
    attrs: {
      "data-href": "https://noctorus.studio",
      "data-width": "100%",
      "data-colorscheme": "dark",
      "data-numposts": "5"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a710ca4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionComment.vue
// module id = 824
// module chunks = 1